import React from "react";
import TreeMarkingListItem from "../../components/treeMarking/TreeMarkingList/TreeMarkingListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const TreeMarkingListPage = ()  => {

    useTitle(t`List Tree Marking`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <TreeMarkingListItem showAdd={true} {...query} />
        </Box>
    )
}

export default TreeMarkingListPage;
